import React from "react";
import PropTypes from "prop-types";
import DesktopView from "./DesktopView";
import MobileView from "./MobileView";
import { useMediaQuery } from "react-responsive";

const ActionCard = ({
  image,
  title,
  titleColor,
  children,
  button_text_1,
  onClick_1,
  onClick_2,
  button_text_2,
  href_1,
  href_2,
  showBtn_2,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div
      className={`card text-decoration-none text-reset nhs-card`}
      style={{  }}
    > 
            {isMobile ? <MobileView href_1={href_1} href_2={href_2} showBtn_2={showBtn_2} button_text_2={button_text_2} onClick_2={onClick_2} onClick_1={onClick_1} button_text_1={button_text_1} image={image} title={title} titleColor={titleColor} >{children} </MobileView> : <DesktopView href_1={href_1} href_2={href_2} showBtn_2={showBtn_2} button_text_2={button_text_2} onClick_2={onClick_2} onClick_1={onClick_1} button_text_1={button_text_1} image={image} title={title} titleColor={titleColor} >{children}</ DesktopView>}
    </div>
  );
};

ActionCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  children: PropTypes.node.isRequired,

  button_text_1: PropTypes.string,
  button_text_2: PropTypes.string,
  onClick_1: PropTypes.func,
  onClick_2: PropTypes.func,
  href_1: PropTypes.string,
  href_2: PropTypes.string,
  showBtn_2: PropTypes.bool,
};

export default ActionCard;
